import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// === ICONOS QUE REALMENTE USAMOS ===
import { faSeedling } from '@fortawesome/free-solid-svg-icons';           // Logo principal
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';     // Contacto
import { faFacebookF, faTwitter, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'; // Redes sociales

import { LanguageContext } from '../context/LanguageContext';
import { Typography } from "@material-tailwind/react";
import { Link } from 'react-router-dom';

const Footer = () => {
  const { language, translations } = useContext(LanguageContext);
  const t = translations[language] || {};

  // Variables bien definidas y reutilizables (opcional, pero muy limpio)
  const iconSeedling = faSeedling;
  const iconPhone = faPhone;
  const iconEnvelope = faEnvelope;
  const iconFacebook = faFacebookF;
  const iconTwitter = faTwitter;
  const iconInstagram = faInstagram;
  const iconLinkedin = faLinkedinIn;

  return (
    <footer className="relative w-full bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-12 overflow-hidden">
      {/* Fondo decorativo */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-10 left-10 w-72 h-72 bg-green-500 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-blue-500 rounded-full blur-3xl animate-pulse"></div>
      </div>

      <div className="relative mx-auto w-full max-w-7xl px-6 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">

          {/* Branding + Descripción + Contacto */}
          <div className="lg:col-span-2">
            <div className="flex items-center group mb-8">
              <div className="w-14 h-14 flex items-center justify-center mr-4 bg-gradient-to-br from-green-400 to-green-600 rounded-2xl shadow-2xl transform group-hover:scale-110 transition-all duration-300">
                <FontAwesomeIcon icon={iconSeedling} className="text-white text-2xl" />
              </div>
              <div>
                <p className="text-2xl font-extrabold bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent leading-tight">
                  VLIR-UOS SHORT INITIATIVE
                </p>
                <p className="text-xl font-bold text-gray-300">SMART FARMING</p>
              </div>
            </div>

            <p className="text-base text-gray-400 mb-10 max-w-2xl leading-relaxed">
              {t.mainTitle || 'Proyecto de investigación en agricultura inteligente y sostenible'}
            </p>

            {/* Contacto */}
            <div className="space-y-6">
              <p className="text-sm font-bold text-gray-500 uppercase tracking-wider">
                {t.contactUs || 'Contacto'}
              </p>

              <div className="flex flex-col sm:flex-row gap-4">
                <a href="tel:+593996645322" className="group flex items-center space-x-4 px-5 py-3 bg-gray-800/50 rounded-xl border border-gray-700 hover:border-green-500 hover:bg-gray-800/80 transition-all duration-300 backdrop-blur-sm">
                  <div className="w-10 h-10 flex items-center justify-center bg-green-500/20 rounded-lg group-hover:bg-green-500/40 transition-colors">
                    <FontAwesomeIcon icon={iconPhone} className="text-green-400 text-lg" />
                  </div>
                  <span className="text-gray-300 group-hover:text-white font-medium">(+593) 99-664-5322</span>
                </a>

                <a href="mailto:ata.rg@epn.edu.ec" className="group flex items-center space-x-4 px-5 py-3 bg-gray-800/50 rounded-xl border border-gray-700 hover:border-blue-500 hover:bg-gray-800/80 transition-all duration-300 backdrop-blur-sm">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-500/20 rounded-lg group-hover:bg-blue-500/40 transition-colors">
                    <FontAwesomeIcon icon={iconEnvelope} className="text-blue-400 text-lg" />
                  </div>
                  <span className="text-gray-300 group-hover:text-white font-medium">ata.rg@epn.edu.ec</span>
                </a>
              </div>
            </div>
          </div>

          {/* Enlaces rápidos + Redes sociales */}
          <div className="space-y-10">
            {/* Enlaces rápidos */}
            <div>
              <Typography variant="h6" className="mb-6 text-lg font-bold text-white flex items-center">
                <span className="w-1 h-8 bg-gradient-to-b from-green-400 to-blue-500 mr-3 rounded-full"></span>
                {t.quickLinks || 'Enlaces rápidos'}
              </Typography>

              <ul className="space-y-3">
                {[
                  { to: "/", label: t.home || "Inicio" },
                  { to: "/que-hacemos", label: t.whatWeDo || "¿Qué hacemos?" },
                  { to: "/noticias", label: t.news || "Noticias" },
                  { to: "/geoportal", label: t.geoportal || "Geoportal" },
                  { to: "/contactos", label: t.contactUs || "Contactos" },
                ].map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="group flex items-center text-gray-400 hover:text-white transition-all duration-200 text-base">
                      <span className="w-0 group-hover:w-3 h-0.5 bg-green-400 mr-0 group-hover:mr-3 transition-all duration-300"></span>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Redes sociales */}
            <div>
              <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-5">
                Síguenos
              </p>
              <div className="flex space-x-4">
                <a href="https://www.facebook.com/ATAResearch" target="_blank" rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center bg-gray-800 rounded-xl text-gray-400 hover:text-white hover:bg-blue-600 transition-all duration-300 transform hover:scale-110 hover:shadow-xl border border-gray-700">
                  <FontAwesomeIcon icon={iconFacebook} className="text-lg" />
                </a>
                <a href="https://x.com/AtaResearch" target="_blank" rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center bg-gray-800 rounded-xl text-gray-400 hover:text-white hover:bg-sky-500 transition-all duration-300 transform hover:scale-110 hover:shadow-xl border border-gray-700">
                  <FontAwesomeIcon icon={iconTwitter} className="text-lg" />
                </a>
                <a href="https://www.instagram.com/ata_research_group/" target="_blank" rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center bg-gray-800 rounded-xl text-gray-400 hover:text-white hover:bg-pink-600 transition-all duration-300 transform hover:scale-110 hover:shadow-xl border border-gray-700">
                  <FontAwesomeIcon icon={iconInstagram} className="text-lg" />
                </a>
                <a href="https://www.linkedin.com/company/ata-research-group1" target="_blank" rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center bg-gray-800 rounded-xl text-gray-400 hover:text-white hover:bg-blue-700 transition-all duration-300 transform hover:scale-110 hover:shadow-xl border border-gray-700">
                  <FontAwesomeIcon icon={iconLinkedin} className="text-lg" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="my-10 relative">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-700"></div>
          </div>
          <div className="relative flex justify-center">
            <div className="px-6 bg-gradient-to-r from-transparent via-gray-900 to-transparent">
              <div className="w-3 h-3 bg-gradient-to-r from-green-400 to-blue-500 rounded-full shadow-lg"></div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="flex flex-col md:flex-row items-center justify-between text-sm text-gray-500">
          <p className="flex items-center space-x-2">
            <span>© {new Date().getFullYear()}</span>
            <span className="hidden sm:inline">•</span>
            <span>{t.copyright || 'Todos los derechos reservados'}</span>
          </p>

          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <Link to="/politica-privacidad" className="hover:text-white transition-colors">
              Política de Privacidad
            </Link>
            <span className="text-gray-600">•</span>
            <Link to="/terminos-uso" className="hover:text-white transition-colors">
              Términos de Uso
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;